import styled from "styled-components";

export const StyledHistoryTechSkillModal = styled.div`
  display: flex;
  flex-direction: column;
  height: 60vh;
  width: 60vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.XL}px) {
    width: 80vw;
    height: 70dvh;
  }

  & .form-row-level {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }

  & .form-row {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    column-gap: 20px;
    row-gap: 20px;
    gap: 20px;

    &:first-child > section {
      max-width: 320px;
    }
  }
`;

export const StyledAlertMessage = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;
